import { ChakraBox } from '@equip.health/ui';

import OverviewLoading from '~/components/common/OverviewLoading';
import SectionHeader from '~/components/common/SectionHeader';
import { PatientTabs } from '~/lib/constants/patients.constants';
import { PatientTabsCollection } from '~/lib/hooks/usePatientTabsCollection';
import { useGetPatientNoteSummaryDashboardReportLinkQuery } from '~/store/services/reports';

type Props = {
  patientId: string;
};
export const NoteSummariesOverview = ({ patientId }: Props) => {
  const {
    data: patientNoteSummaryDashboardReportLink,
    isFetching: isReportLinkLoading,
  } = useGetPatientNoteSummaryDashboardReportLinkQuery(patientId);

  return (
    <>
      <SectionHeader
        action={{
          linkTo: PatientTabsCollection[PatientTabs.NOTES].subPath,
          patientId,
          rightLinkText: 'View all notes',
        }}
        headerText="Note summaries"
      />
      <ChakraBox
        background="white"
        borderColor="neutral.line"
        borderRadius="16px"
        borderStyle="solid"
        borderWidth="1px"
        id="insights-overview-section"
        margin="1px"
        padding="4px"
      >
        {isReportLinkLoading && <OverviewLoading />}
        {!isReportLinkLoading && (
          <iframe
            height="400px"
            src={patientNoteSummaryDashboardReportLink}
            title={`patient_note_summary_dashboard_report_${patientId}`}
            width="100%"
          />
        )}
      </ChakraBox>
    </>
  );
};
